fx.ns("shared.popups", class NewEditorOpened extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personWorried );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text: fx.text("Votre album a été ouvert ailleurs"), className:"title center"}));
        this.addChild(new fx.components.Text({text: fx.text("Pour éviter des problèmes de sauvegarde, veuillez garder l'album ouvert dans une page seulement."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

    onClose()
    {
        super.onClose();

        this.data.event("exit-editor");
    }
});